import React from 'react';
import { BulkUploadDetailsSchemaContract } from 'schemas/BulkUploadDetailsSchema';
import { ExecutionSuccessfullModal } from '../BladeComponents/ExecutionModals/ExecutionSuccessfullModal';
import { BulkUploadPreviewModals } from '../types';
import { ExecutionInProgressModal } from '../BladeComponents/ExecutionModals/ExecutionInProgressModal';
import { ExecutionFailureModal } from '../BladeComponents/ExecutionModals/ExecutionFailureModal';

export type UsePreviewModalsProps = {
  bulkUploadRecord: BulkUploadDetailsSchemaContract[0];
  modalToDisplay: BulkUploadPreviewModals;
  labelMap?: {
    success?: {
      mainText?: string;
      subText?: string;
      buttonText: string;
    };
  };
  clickHandlers: {
    onClickGetErrorReport: () => void;
    onClickGoBack: () => void;
    onClickSuccessCallback: () => void;
  };
};

export const useBladePreviewModals = ({
  bulkUploadRecord,
  modalToDisplay,
  clickHandlers,
  labelMap,
}: UsePreviewModalsProps) => {
  return (
    <>
      <ExecutionInProgressModal
        isOpen={modalToDisplay === BulkUploadPreviewModals.SHOW_IN_PROGRESS_MODAL}
      />
      <ExecutionFailureModal
        isOpen={modalToDisplay === BulkUploadPreviewModals.SHOW_PARTIAL_UPLOAD_MODAL}
        bulkUploadRecord={bulkUploadRecord}
        clickHandlers={clickHandlers}
      />
      <ExecutionSuccessfullModal
        isOpen={modalToDisplay === BulkUploadPreviewModals.SHOW_SUCCESS_MODAL}
        mainText={
          labelMap?.success?.mainText
            ? labelMap.success.mainText
            : 'Upload successfully processed🎉'
        }
        subText={
          labelMap?.success?.subText
            ? labelMap.success.subText
            : 'View updated information using the link below.'
        }
        buttonText={labelMap?.success?.buttonText}
        callBackOnClick={clickHandlers.onClickSuccessCallback}
      />
    </>
  );
};
